import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-blue-50">
      <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  // Staff have their own portal; the customer Store is for customers (and admin preview).
  if (user.role === "salesman") return <Navigate to="/staff" replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login?role=admin" replace />;
  if (user.role !== "admin") return <Navigate to={user.role === "salesman" ? "/staff" : "/dashboard"} replace />;
  return children;
}

export function StaffRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login?role=staff" replace />;
  if (user.role !== "salesman") return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  return children;
}

export function RoleLanding() {
  const { user } = useAuth();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  const dest = user.role === "admin" ? "/admin" : user.role === "salesman" ? "/staff" : "/dashboard";
  return <Navigate to={dest} replace />;
}
